import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';

import { BadgeState } from './types';

import { Icon, IconName, IconSize } from '../Icon';

import styles from './Badge.module.scss';

export type BadgeProps = PropsWithChildren<{
  state?: BadgeState;
  title?: string;
  tag?: keyof JSX.IntrinsicElements;
  icon?: IconName;
  className?: string;
}>;

export const Badge: FC<BadgeProps> = ({
  state = BadgeState.NEUTRAL,
  title,
  tag: Tag = 'span',
  icon,
  className,
  children,
}) => {
  const rootClassNames = classNames(styles.root, {
    [styles.warning]: state === BadgeState.WARNING,
    [styles.error]: state === BadgeState.ERROR,
    [styles.success]: state === BadgeState.SUCCESS,
    [styles.note]: state === BadgeState.NOTE,
    [styles.brand]: state === BadgeState.BRAND,
  }, className);

  return (
    <Tag className={rootClassNames}
         title={title}>
      {icon && (
        <Icon icon={icon}
              size={IconSize.MEDIUM} />
      )}
      {children}
    </Tag>
  );
};
